import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layouts/header/header.component';

import { appConfig } from './app.config';
import { AccessDeniedComponent } from './views/access-denied/access-denied.component';
import { SharedModule } from './shared/shared.module';
import { AuthenticationService, CommonService, SpinnerService } from './shared/services';
import { MessageService } from 'primeng/api';
import { LandingModule } from './views/landing/landing.module';
import { ReportDetailsModule } from './views/report-details/report-details.module';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    HeaderComponent,
    AccessDeniedComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    LandingModule,
    ReportDetailsModule,
    AppRoutingModule,
    SharedModule,
    ToastModule,
    CalendarModule,
    ButtonModule,
    DialogModule
  ],
  providers: [
    ...appConfig.providers,
    SpinnerService,
    MessageService,
    AuthenticationService,
    CommonService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
